<template>
    <BaseWidget>
        <div>
            <div v-for="step in widget.content.steps" :key="step.key">
                <div v-if="step.type === 'multi_step'">
                    <div><OnboardingStep :step="step" /></div>
                    <div v-for="subStep in step.sub_steps" class="ml-5" :key="subStep.key">
                        <OnboardingStep :step="subStep" />
                    </div>
                </div>
                <div v-else>
                    <OnboardingStep :step="step" />
                </div>
            </div>
        </div>

        <template v-slot:footer>
            <AppButton
                element="button"
                type="button"
                desired-action
                v-if="widget.content.is_complete && !showConfetti"
                @click="complete"
            >
                {{ $t('messages.complete_onboarding_button_text') }}
            </AppButton>
        </template>

        <Teleport to="body">
            <div class="relative z-20 pointer-events-none">
                <div class="fixed z-10 inset-0">
                    <div class="flex items-end items-center justify-center min-h-full p-4">
                        <ConfettiExplosion v-if="showConfetti" />
                    </div>
                </div>
            </div>
        </Teleport>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
import AppButton from '@/components/AppButton.vue';
import OnboardingStep from '@/components/OnboardingStep.vue';

export default {
    name: 'SchoolOnboardingWidget',
    components: {
        OnboardingStep,
        AppButton,
        BaseWidget,
    },
};
</script>
<script setup>
import { ref } from 'vue';
import ConfettiExplosion from 'vue-confetti-explosion';
import axios from 'axios';

const props = defineProps({
    widget: {
        required: true,
        type: Object,
    },
});

let showConfetti = ref(false);

const complete = () => {
    if (showConfetti.value === false) {
        showConfetti.value = true;
        axios.post(props.widget.content.url);
    }
};
</script>
